import React from 'react';
import DynamicDialogue from '../common/components/interactive-dialogue/components/dynamic-dialogue/dynamic-dialogue';
import InteractiveDialogueContainer from '../common/components/interactive-dialogue/components/interactive-dialogue-container';
import {
  popEmeraldModal,
  pushEmeraldModal,
} from '../common/emerald-modal-manager/emerald-modal-manager';
import { EmeraldDialogTypes } from '../common/enumerations/emerald-dialog-types';
import { endOfDayExecute } from './business-logic/end-of-day-execute';
import { ExecutionTiming } from './business-logic/end-of-day-status';

export const showEndOfDayManualApprovalDialog = (): void => {
  pushEmeraldModal(<EndOfDayManualApproval />);
};

const EndOfDayManualApproval: React.FC = (): JSX.Element | null => {
  const handleEndOfDayExecute = async (executionTiming: ExecutionTiming): Promise<void> => {
    await endOfDayExecute(executionTiming);
    closeEndOfDayDialog();
  };
  const closeEndOfDayDialog = (): void => {
    popEmeraldModal();
  };
  return (
    <InteractiveDialogueContainer
      dialogTestIdPrefix='end-of-day'
      open={true}
      acceptButtonLabel={'Ok'}
      handleClose={(): void => {
        handleEndOfDayExecute(ExecutionTiming.PostponeMax);
      }}
      handleAccept={(): void => {
        handleEndOfDayExecute(ExecutionTiming.Immediate);
      }}
      component={
        <DynamicDialogue
          iconType={EmeraldDialogTypes.Warning}
          title={'EndOfDay_Caption'}
          message={'EndOfDay_Message'}
        ></DynamicDialogue>
      }
    />
  );
};
export default EndOfDayManualApproval;
